import React, { useEffect, useState } from "react";
import "../styles/Toast.css";

function Toast({ message, type,triggerId }) {
  const [visibleMessage, setVisibleMessage] = useState(message);

  useEffect(() => {
    setVisibleMessage(message); // Update local state when new message comes

    if (message) {
      const timer = setTimeout(() => setVisibleMessage(null), 6000);
      return () => clearTimeout(timer);
    }
  }, [triggerId,message]);

  if (!visibleMessage) return null;

  return (
    <div className={`toast-container toast-${type}`}>
      <span>{visibleMessage}</span>
      <button
        type="button"
        className="btn-close ms-3"
        aria-label="Close"
        onClick={() => setVisibleMessage(null)}
      ></button>
    </div>
    
  );
}

export default Toast;
